import {createAction, props} from '@ngrx/store';
import {ISystemParameterGroup} from "../models/system-parameter-group";

export const setParameterGroupList = '[ParameterGroup] setParameterGroupList';
export const fetchParameterGroupList = '[ParameterGroup] fetchParameterGroupList';
export const addParameterGroupList = '[ParameterGroup] addParameterGroupList';
export const removeParameterGroupList = '[ParameterGroup] removeParameterGroupList'
export const updateParameterGroupList = '[ParameterGroup] updateParameterGroupList';

export const setParameterGroupListAction = createAction(setParameterGroupList, (parameterGroupList) => {
  return {payload: parameterGroupList}
});

export const fetchParameterGroupListAction = createAction(fetchParameterGroupList);

export const addParameterGroupListAction = createAction(fetchParameterGroupList, (parameterGroup) => parameterGroup);

export const updateParameterGroupListAction = createAction(
  fetchParameterGroupList,
  (parameterGroup) => parameterGroup
);

export const removeParameterGroupListAction = createAction(
  fetchParameterGroupList,
  props<{ parameterGroup: ISystemParameterGroup }>()
);
